"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layout = void 0;
var layout = {
  header: {
    height: '84px'
  },
  container: {
    maxWidth: '1500px',
    margin: '0 auto'
  },
  content: {
    maxWidth: '1280px',
    margin: '0 auto'
  }
};
exports.layout = layout;